export default __webpack_public_path__ + "static/media/1985.e33e1c95.png";